import React, { useCallback } from "react"
import * as AppConstants from "@/utility/AppConstants"
import "Css/table.css"
import { TableFieldsMultiAnno } from "@/utility/model"
function TabAnomalie(props: TableFieldsMultiAnno) {
    let elemNonDisponibile = AppConstants.ELEMENTO_NON_DISPONIBILE
    return (
        <React.Fragment>
            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {" "}
                    {AppConstants.DATI_ANOMALIA_GESTIONE_BENI_STRUMENTALI}{" "}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {props.campo1 !== undefined
                            ? props.campo1.anomaliaBsNum
                            : elemNonDisponibile}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2.anomaliaBsNum
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                <td>
                    {props.campo3 !== undefined
                        ? props.campo3.anomaliaBsNum
                        : elemNonDisponibile}
                </td>
            </tr>
            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {" "}
                    {AppConstants.DATI_ANOMALIA_ATTIVITA_NON_INERENTI}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {props.campo1 !== undefined
                            ? props.campo1.anomaliaInerNum
                            : elemNonDisponibile}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2.anomaliaInerNum
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                <td>
                    {props.campo3 !== undefined
                        ? props.campo3.anomaliaInerNum
                        : elemNonDisponibile}
                </td>
            </tr>
        </React.Fragment>
    )
}
export default TabAnomalie
